export default __webpack_public_path__ + "static/media/45_mobile.fe643155.jpg";